import { render, staticRenderFns } from "./SentNotificationsModal.container.vue?vue&type=template&id=5ad982d6&"
import script from "./SentNotificationsModal.container.vue?vue&type=script&lang=ts&"
export * from "./SentNotificationsModal.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports